var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Charge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E3_Charge_svg__clip0_3167_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.424 10.702c.16-.22.509-.107.509.165v20.727c0 .156.126.282.281.282h17.867c.23 0 .363.26.228.446l-24.1 33.228a.281.281 0 01-.51-.165V44.658a.281.281 0 00-.28-.282H16.551a.281.281 0 01-.228-.447l24.1-33.227z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "E3_Charge_svg__clip0_3167_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/E3_Charge.e93d3935.svg";
export { SvgE3Charge as ReactComponent };